import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-dictionary-connection",
  "use": "foquz-icon-dictionary-connection-usage",
  "viewBox": "0 0 15 17",
  "content": "<symbol viewBox=\"0 0 15 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-dictionary-connection\"><path d=\"M5 5h5m-9 9V3a2 2 0 012-2h11v15H3a2 2 0 01-2-2zm0 0a2 2 0 012-2h11\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol